import { render } from "./App.vue?vue&type=template&id=3c402e6b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./styles/main.scss?vue&type=style&index=0&lang=scss"
import "./App.vue?vue&type=style&index=1&id=3c402e6b&lang=css"

import exportComponent from "C:\\Sistemas\\CredenciamentoSUS\\aplicacao\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__